// extracted by mini-css-extract-plugin
export default {"timeLeftBox":"TimeLeftBox_timeLeftBox__R4ZCX","digitos":"TimeLeftBox_digitos__5Vh9U","separador":"TimeLeftBox_separador__fbiiI"};